import { formatDate } from './date-helpers';

/**
 * Säker rendering av strängfält som kommer från API:t.
 *
 * handleDates() i api/mutator/custom-instance.ts går igenom hela svaret och gör om varje
 * sträng som matchar ÅÅÅÅ-MM-DD (eller ISO-datumtid) till ett Date-objekt. Den gör ingen
 * skillnad på fält som är datum och fritextfält som råkar innehålla ett datum — så ett
 * `string`-fält kan vara ett Date vid runtime trots att TypeScript säger något annat.
 * Renderas det direkt kraschar hela sidan med "Objects are not valid as a React child".
 *
 * Använd den här för fritextfält där användaren kan ha skrivit in ett datum, t.ex.
 * anledningen till att någon inte är bokningsbar, eller från-/till-värden i ändringsloggen.
 */
const renderApiValue = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return '';
  if (value instanceof Date) return formatDate(value);
  return String(value);
};

export default renderApiValue;
